import React from 'react';
import ReactDOM from 'react-dom';
import BuyFund from 'wt-react/dist/components/BuyFund/BuyFund.js';
import './index.css';

// App script in page will provide the id to mount.
// Taken from https://stackoverflow.com/questions/53562804/how-to-include-the-same-react-app-twice-on-the-same-page
window.mount = function (id) {

  const element = document.getElementById(id);
  const windowAppId = `${process.env.REACT_APP_WINDOW_APP_ID}` ? `${process.env.REACT_APP_WINDOW_APP_ID}` : 'tradefundvars';
  const params = {};

  params.wtRegion = window[windowAppId] && `${window[windowAppId].wtRegion}` && `${window[windowAppId].wtRegion}` !== 'undefined' ? `${window[windowAppId].wtRegion}` : "US";
  params.dataspanApiUrl = `${process.env.REACT_APP_API_URL}`;

  // Split the URL on '#' and '?' first in case there is an anchor or param in URL, then by '/'
  const urlSplit = window.location.href.split('#')[0].split('?')[0].split('/');

  // Get the fund ticker from the URL. This should always be the last thing after the last slash, and more than 
  // 3 characters, 5 or less.
  if (urlSplit[urlSplit.length - 1] && urlSplit[urlSplit.length - 1].length >= 3 && urlSplit[urlSplit.length - 1].length <= 5) {
    params.ticker = urlSplit[urlSplit.length - 1];
  } else if (urlSplit[urlSplit.length - 2] && urlSplit[urlSplit.length - 2].length >= 3 && urlSplit[urlSplit.length - 2].length <= 5) {
    params.ticker = urlSplit[urlSplit.length - 2];
  } else {
    params.ticker = 'NONE';
  }

  // Get the var for hide or showing the Compare button
  params.showCompare = element.dataset.showcompare && element.dataset.showcompare === 'false' ? false : true;
  // get var for show competitor
  params.showCompetitors = element.dataset.showcompetitors && element.dataset.showcompetitors === 'false' ? false : true;

  // get var for show morningstar
  params.showMorningstar = element.dataset.showmorningstar && element.dataset.showmorningstar === 'true' ? true : false;

  // get var for show morningstar all (less than 4 stars)
  params.showMorningstarAll = element.dataset.showmorningstarall && element.dataset.showmorningstarall === 'true' ? true : false;

  // Deep copy the params to remove issues with multi apps and Redux
  const paramsCopy = JSON.parse(JSON.stringify(params));

  // render
  ReactDOM.render((
    <BuyFund
      ticker={paramsCopy.ticker}
      dataspanApiUrl={paramsCopy.dataspanApiUrl}
      showCompare={paramsCopy.showCompare}
      showCompetitors={paramsCopy.showCompetitors}
      showMorningstar={paramsCopy.showMorningstar}
      showMorningstarAll={paramsCopy.showMorningstarAll}
      wtRegion={paramsCopy.wtRegion}
    />
  ), element);
}
